import React from "react";

const QuantityStepper = ({
  className,
  value,
  onIncrease,
  onDecrease,
  min = 1,
  max,
}) => {
  const atMin = value <= min;
  const atMax = value >= max;

  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <button
        onClick={onDecrease}
        disabled={atMin}
        className="w-10 h-10 rounded-full bg-primary600 text-white flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
      >
        −
      </button>
      <span className="min-w-11 text-lg font-medium">{value}</span>
      <button
        onClick={onIncrease}
        disabled={atMax}
        className="w-10 h-10 rounded-full bg-primary600 text-white flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed"
      >
        +
      </button>
    </div>
  );
};

export default QuantityStepper;